module.exports = __webpack_public_path__ + "static/assets/dcb879fb033a3b1e0a3e8ccac8f9c6da.png";